import { vsName as serverName } from "../../../Server";
import { vsName as mealLogDownloadServiceName } from "../../../Pages/MealLog/mealLogDownloadService"

export class DetailMealLogController {
  constructor(server, mealLogDownloadService) {
    this.server = server;
    this.currentItems = [];
    this.count = 0;
    this.page = 1;
    this.pageSize = 50;

    this.mealLogDownloadService = mealLogDownloadService
  }

  $onInit() {
    this.pageChanged(this.page);
  }

  downloadCsv(){
    this.mealLogDownloadService.downloadCsvForMachine(this.machine)
  }

  pageChanged(pageNumber) {
    this.server
      .mealLogFind(
        this.machineId,
        this.pageSize,
        (pageNumber - 1) * this.pageSize
      )
      .then((queryResult) => {
        this.currentItems = queryResult.Results;
        this.count = queryResult.Total;
      });
  }
}
DetailMealLogController.$inject = [serverName, mealLogDownloadServiceName];
